import { useState } from "react";
import { Button, Collapse } from "reactstrap";

const AiSuggestion = ({ detection, t }) => {
  const [isEvidenceOpen, setIsEvidenceOpen] = useState(false);
  const evidence = Array.isArray(detection?.evidence) ? detection.evidence : [];
  const suggestedValue =
    detection?.is_ai_system === true
      ? t("Yes")
      : detection?.is_ai_system === false
      ? t("No")
      : t("Not determined");

  return (
    <div className="software-ai-suggestion">
      <div className="software-ai-suggestion__summary">
        <strong>{t("Reason")}:</strong>

        {/* <strong>{t("AI suggestion")}:</strong> {suggestedValue}
        {detection?.confidence && (
          <span className="software-ai-suggestion__confidence">
            {t("Confidence")}: {t(detection.confidence)}
          </span>
        )} */}
      </div>

      <div className="software-ai-reason">
        {detection?.reason || t("No AI reason available for this asset.")}
      </div>

      {evidence.length > 0 && (
        <>
          <Button
            className="software-ai-suggestion__toggle"
            color="link"
            type="button"
            onClick={() => setIsEvidenceOpen((isOpen) => !isOpen)}
          >
            {isEvidenceOpen ? t("Hide evidence") : t("View evidence")}
          </Button>
          <Collapse isOpen={isEvidenceOpen}>
            <ul className="software-ai-suggestion__evidence">
              {evidence.map((item, index) => (
                <li key={`${item?.url || item?.title || "evidence"}-${index}`}>
                  {item?.url ? (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.title || item.url}
                    </a>
                  ) : (
                    <strong>{item?.title || t("Evidence")}</strong>
                  )}
                  {item?.snippet && <p>{item.snippet}</p>}
                </li>
              ))}
            </ul>
          </Collapse>
        </>
      )}
    </div>
  );
};

export default AiSuggestion;

